import React, { useContext } from "react";

import MasterLanguagesTabPanel from "./media/MasterLanguagesTabPanel";
import MediaTranslations from "./media/MediaTranslations";
import ContentContext from "../../contexts/ContentContext";
import "../../css/admin/content-page.scss";
import TabsMaster from "../content/TabsMaster";

import type { JSX } from "react";

import type { ContentContextValues } from "../content/ContentTabs";

function TabContentLanguages(): JSX.Element {
  const { item, translationsRef } =
    useContext<ContentContextValues>(ContentContext);

  if (item.type === "master") {
    return (
      <TabsMaster>
        <MasterLanguagesTabPanel />
      </TabsMaster>
    );
  }

  return <MediaTranslations ref={translationsRef} item={item} />;
}

export default TabContentLanguages;
